// src/pages/PerformerDashboard/CreateBandProfile.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ResponsiveButton from "../../components/ResponsiveButton/ResponsiveButton";

export default function CreateBandProfile() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    slug: "",
    name: "",
    description: "",
    genre: "",
    membership_level: "basic",
    video_link: "",
    band_email: "",
    band_phone: "",
    band_address: "",
    location: "",
    profile_image: "",
    og_image_url: "",
    artist_type: "",
    instruments: "",
    additional_services: "",
    repertoire: "",
    gallery_images: "[]",
    audio_tracks: "[]",
    performance_regions: "",
    available_sets: "",
    facebook: "",
    instagram: "",
    tiktok: "",
    youtube: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setForm((f) => ({ ...f, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = new URLSearchParams();
      Object.entries(form).forEach(([k,v]) => payload.append(k, v));
      const { data } = await axios.post(
        "https://spiderlegsproductions.com/api/create_band.php",
        payload.toString(),
        { headers: { 'Content-Type':'application/x-www-form-urlencoded' } }
      );
      if (data.success) {
        // Siirry omaan dashboardiin tai muokkaussivulle
        navigate(`/performer-dashboard?created=${data.bandId}`);
      } else {
        alert("Virhe: " + data.error);
      }
    } catch (err) {
      console.error(err);
      alert("Palvelinvirhe profiilia luodessa.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-24 px-4 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Luo esiintyjäprofiili</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        {Object.entries(form).map(([key, val]) => (
          <div key={key}>
            <label htmlFor={key} className="block font-semibold mb-1">
              {key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())}
            </label>
            <input
              id={key}
              type="text"
              value={val}
              onChange={handleChange}
              className="w-full p-2 border rounded"
            />
          </div>
        ))}
        <ResponsiveButton type="submit" variant="addtocart" disabled={loading}>
          {loading ? "Tallennetaan…" : "Luo profiili"}
        </ResponsiveButton>
      </form>
    </div>
  );
}
